import { render, staticRenderFns } from "./setting-create-user-role-sidebar.vue?vue&type=template&id=85d1ea40&scoped=true&"
import script from "./setting-create-user-role-sidebar.vue?vue&type=script&lang=js&"
export * from "./setting-create-user-role-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./setting-create-user-role-sidebar.vue?vue&type=style&index=0&id=85d1ea40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d1ea40",
  null
  
)

export default component.exports